import { AddCircleOutline } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CalendarIcon } from "~/src/components/Icons/Icons";
import ButtonDefault, { ButtonVariant } from "../../../../components/Button/ButtonDefault";

export type SuccessDialogButtonsProps = {
  valgtOmradekode?: string | number;
};

const SuccessDialogButtons = (props: SuccessDialogButtonsProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const navigateToOversiktJakdager = () =>
    navigate("/oversikt", { state: { activeTab: 0, valgtOmradekode: props.valgtOmradekode } });
  const navigateToOversiktSkutteDyr = () =>
    navigate("/oversikt", { state: { activeTab: 1, valgtOmradekode: props.valgtOmradekode } });
  const navigateToRegistrering = () => navigate("/registrering");
  return (
    <>
      <ButtonDefault
        leftAdjusted
        id={"registreringSuccessDialogFellingsInfoButton"}
        variant={ButtonVariant.Primary}
        label={t("pages.registrering.dialogs.overforingSuccess.leggTilFellingsInfoButtonText")}
        onClick={() => navigateToOversiktSkutteDyr()}
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="16"
            viewBox="0 0 24 16"
            fill="none"
            role="graphics-symbol"
          >
            <path
              d="M0 16V13.3333H16V16H0ZM0 9.33333V6.66667H24V9.33333H0ZM0 2.66667V0H24V2.66667H0Z"
              fill="currentColor"
            />
          </svg>
        }
      />
      <ButtonDefault
        leftAdjusted
        id={"registreringSuccessDialogSeMineRegistreringerButton"}
        variant={ButtonVariant.Secondary}
        icon={<CalendarIcon className="text-ldir-blue-800" />}
        label={t("pages.registrering.dialogs.overforingSuccess.seMineRegistreringerButtonText")}
        onClick={() => navigateToOversiktJakdager()}
      />
      <ButtonDefault
        id={"registreringSuccessDialogNyRegistreringButton"}
        leftAdjusted
        variant={ButtonVariant.Secondary}
        label={t("pages.registrering.dialogs.overforingSuccess.nyRegistreringButtonText")}
        icon={<AddCircleOutline className="text-ldir-blue-800" />}
        onClick={() => navigateToRegistrering()}
      />
    </>
  );
};

export default SuccessDialogButtons;
